import styled from 'styled-components'
import { Box } from '@usap/uicomponents'

const Container = styled(Box)`
  padding-top: ${props => props.theme.global.edgeSize.small};

  @media (min-width: ${props => props.theme.global.breakpoints.laptop.value}px) {
    margin: 0px auto;
  }
`

export default Container
